import { _ } from "libs";
import React from "react";
import { Form, Field } from "react-final-form";
import { Profile, NotificationSettingsArray } from "../../types";
import arrayMutators from "final-form-arrays";
import { FieldArray } from "react-final-form-arrays";

type Props = {
	onChange: (notificationSettings: Profile["notificationSettings"]) => void;
	profile: Profile;
};

function mapNotificationSettings(notificationSettings: Profile["notificationSettings"]): NotificationSettingsArray {
	const result = [] as NotificationSettingsArray;

	Object.keys(notificationSettings).forEach((key: string) => {
		const setting = notificationSettings[key];

		result.push({
			name: key,
			email: setting.email,
			push: setting.push,
		});
	});

	return result;
}

function reduceFormValues(values: NotificationSettingsArray): Profile["notificationSettings"] {
	let result = {};

	values.forEach(({ name, email, push }) => {
		result[name] = {
			email,
			push,
		};
	});

	return result;
}

export function NotificationsForm({ onChange, profile }: Props) {
	const notificationSettings = mapNotificationSettings(profile.notificationSettings);

	return (
		<Form
			onSubmit={(values: { notificationSettings: NotificationSettingsArray }) => {
				const notificationSettings = reduceFormValues(values.notificationSettings);
				onChange(notificationSettings);
			}}
			mutators={{
				...arrayMutators,
			}}
			initialValues={{ notificationSettings }}
			render={({ handleSubmit, submitting, invalid }) => (
				<form onSubmit={handleSubmit} className="fullWidth">
					<FieldArray name="notificationSettings">
						{({ fields }) => {
							return fields.map((name, index) => {
								const field = fields.value[index];
								return (
									<div className="row" key={name}>
										<div className="name">
											<div className="title">{_(`notificationsForm.${field.name}.title`)}</div>
											<div className="description">
												{_(`notificationsForm.${field.name}.description`)}
											</div>
										</div>
										<Field name={`${name}.email`} type="checkbox">
											{({ input }) => (
												<div className="field email medium">
													<input {...input} type="checkbox" checked={field.email} />
												</div>
											)}
										</Field>
										<Field name={`${name}.push`} type="checkbox">
											{({ input }) => (
												<div className="field push medium">
													<input {...input} type="checkbox" checked={field.push} />
												</div>
											)}
										</Field>
									</div>
								);
							});
						}}
					</FieldArray>
					<div className="buttons">
						<button type="submit" className="button" disabled={submitting || invalid}>
							{_("saveBtn")}
						</button>
					</div>
				</form>
			)}
		/>
	);
}

export default NotificationsForm;
